/* eslint-disable jsx-a11y/prefer-tag-over-role */

import React from 'react';
import { SecondaryGridRow } from './SecondaryGridRow';

export const SecondaryGrid = ({ headers, rows, onOpenModal }) => {
  const totalColumns = Math.max(
    headers.reduce((count, header) => {
      return count + (header.subheaders ? header.subheaders.length : 1);
    }, 0),
    1
  );

  const gridStyle = {
    gap: '0rem',
  };

  const rowGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${totalColumns}, 1fr)`
  };

  const hasHeaders = headers && headers.length > 0;
  const hasRows = rows && rows.length > 0;
  return (
    <div style={gridStyle} role="grid" aria-label="Secondary monitoring data">
      {hasHeaders ? (
        <div role="row" style={rowGridStyle}>
          {headers.map((header, index) => {
            if (typeof header === 'string') {
              return (
                <div 
                  key={index} 
                  className="grid-header-secondary single" 
                  style={{ gridRow: '1 / 3' }}
                  role="columnheader"
                >
                  {header}
                </div>
              );
            } else {
              return (
                <React.Fragment key={index}>
                  <div 
                    className="grid-header-secondary split-main-title-secondary" 
                    style={{ 
                      gridColumn: `span ${header.subheaders.length}`,
                      gridRow: '1'
                    }}
                    role="columnheader"
                  >
                    {header.title}
                  </div>
                  {header.subheaders.map((subheader, subIndex) => (
                    <div 
                      key={subIndex} 
                      className="grid-header-secondary split-subheader-secondary"
                      style={{ gridRow: '2' }}
                      role="columnheader"
                    >
                      {subheader}
                    </div>
                  ))}
                </React.Fragment>
              );
            }
          })}
        </div>
      ) : (
        <div role="row" style={rowGridStyle}>
          <div role="columnheader" style={{ gridColumn: `1 / span ${Math.max(totalColumns, 1)}` }}>No data</div>
        </div>
      )}

      {/* Data rows */}
      {hasRows ? (
        rows.map((row, index) => (
          <SecondaryGridRow 
            key={row.id} 
            row={row} 
            rowIndex={index} 
            numHeaders={totalColumns} 
            onOpenModal={onOpenModal} 
            rowGridStyle={rowGridStyle}
          />
        ))
      ) : (
        <div role="row" style={rowGridStyle}>
          <div role="gridcell" style={{ gridColumn: `1 / span ${Math.max(totalColumns, 1)}` }}>No data available</div>
        </div>
      )}
    </div>
  );
};